import { createFileRoute } from '@tanstack/react-router'
import { OpsInboxTabContent } from '@/pages/OpsInbox'

export const Route = createFileRoute('/_authenticated/ops-inbox/failed-operations')({
  component: () => <OpsInboxTabContent filterType="failed_operation" />,
})
